'use client'

import OrderCard from "./OrderCard"
import Pagination from "@/components/elements/Pagination"
import Skeleton from "@/components/elements/Skeleton"
import EmptyState from "@/components/elements/EmptyState"
import { useEffect, useState } from "react"
import { ReceiptText } from "lucide-react"

export default function OrderList({ orderList }: { orderList: any }) {
  const [isLoading, setIsLoading] = useState(true)
  const orders = orderList ? orderList : []

  useEffect(() => {
    if (orderList !== undefined) {
      setIsLoading(false)
    }
  }, [orderList])

  if (isLoading) {
    return <OrderListSkeleton />
  }

  return (
    <div className="cont py-4 sm:py-8">
      <div className="flex flex-col gap-y-4">
        <div className="flex flex-col gap-1">
          <div className="font-semibold text-lg text-foreground">Захиалгууд</div>
          <div className="text-sm text-muted-foreground">Таны хийсэн хамгийн сүүлийн захиалгууд</div>
        </div>
        <Pagination items={orders} component={({ item }: { item: any }) => <OrderCard order={item} />} limit={10} empty={OrderNotFound} showSearch={false} searchFields={[]} containerClassName="flex flex-col !gap-y-4 !grid-cols-none !grid-rows-none" />
      </div>
    </div>
  )
}

export function OrderNotFound() {
  return <EmptyState icon={ReceiptText} title="Захиалга байхгүй байна" description="Таны хийсэн захиалгууд энд харагдах болно." />
}

function OrderListSkeleton() {
  return (
    <div className="cont py-8">
      <div className="flex flex-col gap-y-6">
        <div className="flex flex-col gap-1">
          <Skeleton className="w-32 h-7" />
          <Skeleton className="w-64 h-5" />
        </div>
        <div className="flex flex-col gap-y-4 mt-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="w-full h-24" />
          ))}
        </div>
      </div>
    </div>
  )
}